/**
 * A purchase order's number as a link to its page (BLU-1506): mono, in the
 * brand's strong text colour (DESIGN.md section 1, `primary-strong`),
 * underlined on hover. `ordersReturnTo` rides in router state, so the PO
 * page's back button returns to the exact list or view the link was on.
 *
 * One look for a PO number inside running text or a heading: the To buy
 * tab's Order and wait cards, their spares, and the Order Queue's Waiting on
 * blank view.
 */
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export interface PoNumberLinkProps {
  poId: string;
  poNumber: string;
  /** The URL to come back to (filters and search kept); none = the PO page's own default. */
  ordersReturnTo?: string;
  className?: string;
}

export function PoNumberLink({ poId, poNumber, ordersReturnTo, className }: PoNumberLinkProps) {
  return (
    <Link
      to={`/orders/${poId}`}
      state={ordersReturnTo ? { ordersReturnTo } : undefined}
      className={cn('font-mono text-primary-strong underline-offset-4 hover:underline', className)}
    >
      {poNumber}
    </Link>
  );
}
